angular.module('cvsApp').directive("stopccp",function(){
	return {
		scope:{},
		link:function(scope,ele){
			
			ele.on('cut copy paste',function(e){
				e.preventDefault();
			});
		}
	}
});